<div class="flex w-full flex-1 flex-col items-center justify-center px-4">
  <div class="mb-20 w-full max-w-2xl text-center text-surface-700">
    <div
      class="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full
        bg-secondary-700 shadow-md">
      <h1>🚀</h1>
    </div>

    <h1 class="mb-4 font-bold">Hi {{ user()?.first_name }}!</h1>

    <h4 class="text-gray-600">
      Start navigating using the side menu to explore all available features.
    </h4>
  </div>
</div>
